import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  useTheme,
  useMediaQuery,
  Box,
} from '@mui/material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

const REPORT_ROUTES = [
  {
    label: 'Billing Summary',
    shortLabel: 'Billing',
    path: '/billing/finance-summary',
    icon: <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 22 }} />,
  },
  {
    label: 'Service Wise',
    shortLabel: 'Services',
    path: '/billing/service-wise-finance-summary',
    icon: <CategoryOutlinedIcon sx={{ fontSize: 22 }} />,
  },
  {
    label: 'Coordinator Wise',
    shortLabel: 'Coordinators',
    path: '/billing/coordinator-wise-report',
    icon: <PeopleAltOutlinedIcon sx={{ fontSize: 22 }} />,
  },
];

function ReportsMobileBottomNav() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const navigate = useNavigate();

  if (!isMobile) return null;

  const currentPath = location.pathname;
  let activeValue = REPORT_ROUTES.findIndex((r) => currentPath.startsWith(r.path));
  if (activeValue === -1) activeValue = 0;

  return (
    <Box>
      {/* Spacer to prevent page content from being hidden behind fixed bottom bar */}
      <Box sx={{ height: 64, display: { xs: 'block', md: 'none' } }} />

      <Paper
        elevation={10}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          borderTop: '1px solid #e2e8f0',
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(12px)',
          boxShadow: '0 -4px 16px rgba(0, 0, 0, 0.08)',
          pb: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        <BottomNavigation
          showLabels
          value={activeValue}
          onChange={(event, newValue) => {
            const target = REPORT_ROUTES[newValue];
            if (target && target.path !== currentPath) {
              navigate(target.path);
            }
          }}
          sx={{
            height: 58,
            backgroundColor: 'transparent',
            '& .MuiBottomNavigationAction-root': {
              minWidth: 0,
              py: 0.5,
              px: 1,
              color: '#64748b',
              transition: 'all 0.2s ease',
              '&.Mui-selected': {
                color: '#2563eb',
                '& .MuiSvgIcon-root': {
                  transform: 'scale(1.15)',
                  transition: 'transform 0.15s ease',
                },
              },
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.72rem',
                fontWeight: 600,
                mt: 0.2,
                '&.Mui-selected': {
                  fontSize: '0.75rem',
                  fontWeight: 800,
                },
              },
            },
          }}
        >
          {REPORT_ROUTES.map((route) => (
            <BottomNavigationAction
              key={route.path}
              label={route.shortLabel}
              icon={route.icon}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}

export default ReportsMobileBottomNav;
